export const GET_CART_ITEMS = "GET_CART_ITEMS";
export const GET_CART_ITEMS_SUCCESS = "GET_CART_ITEMS_SUCCESS";
export const GET_CART_ITEMS_FAILURE = "GET_CART_ITEMS_FAILURE";

export const GET_ACTIVE_SHOPPING_CART = "GET_ACTIVE_SHOPPING_CART";
export const GET_ACTIVE_SHOPPING_CART_SUCCESS = "GET_ACTIVE_SHOPPING_CART_SUCCESS";
export const GET_ACTIVE_SHOPPING_CART_FAILURE = "GET_ACTIVE_SHOPPING_CART_FAILURE";

export const CREATE_SHOPPING_CART = "CREATE_SHOPPING_CART";
export const CREATE_SHOPPING_CART_SUCCESS = "CREATE_SHOPPING_CART_SUCCESS";
export const CREATE_SHOPPING_CART_FAILURE = "CREATE_SHOPPING_CART_FAILURE";

export const RESET_SHOPPING_CART_DETAILS = "RESET_SHOPPING_CART_DETAILS";

export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const ADD_CART_ITEM_SUCCESS = "ADD_CART_ITEM_SUCCESS";
export const ADD_CART_ITEM_FAILURE = "ADD_CART_ITEM_FAILURE";

export const REVIEW_WARRANTY_DATA = "REVIEW_WARRANTY_DATA";
export const REVIEW_WARRANTY_DATA_SUCCESS = "REVIEW_WARRANTY_DATA_SUCCESS";
export const RESET_REVIEW_WARRANTY_DATA = "RESET_REVIEW_WARRANTY_DATA";

export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const DELETE_CART_ITEM_SUCCESS = "DELETE_CART_ITEM_SUCCESS";
export const DELETE_CART_ITEM_FAILURE = "DELETE_CART_ITEM_FAILURE";

export const UPDATE_ACTIVE_ACTION = "UPDATE_ACTIVE_ACTION";
export const CLEAR_MSG = "CLEAR_MSG";

export const BEGIN_TRANSACTION = "BEGIN_TRANSACTION";
export const BEGIN_TRANSACTION_SUCCESS = "BEGIN_TRANSACTION_SUCCESS";
export const BEGIN_TRANSACTION_FAILURE = "BEGIN_TRANSACTION_FAILURE";

export const RE_SUBMIT_CART = "RE_SUBMIT_CART";
export const RE_SUBMIT_CART_SUCCESS = "RE_SUBMIT_CART_SUCCESS";
export const RE_SUBMIT_CART_FAILURE = "RE_SUBMIT_CART_FAILURE";